import { useState } from 'react';

const C = {
  cream:  '#fdf8f0',
  gold:   '#f0bf6b',
  dark:   '#2a2118',
  blue:   '#1562c8',
};

export function CookieConsent() {
  const [visible, setVisible] = useState(() => !localStorage.getItem('cv_cookie_consent'));

  if (!visible) return null;

  function accept() {
    localStorage.setItem('cv_cookie_consent', 'accepted');
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', { analytics_storage: 'granted' });
    }
    setVisible(false);
  }

  function decline() {
    localStorage.setItem('cv_cookie_consent', 'declined');
    setVisible(false);
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: 24,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 9997,
      background: C.cream,
      border: `2px solid ${C.dark}`,
      boxShadow: `3px 3px 0 ${C.dark}`,
      borderRadius: 4,
      padding: '14px 18px',
      display: 'flex',
      alignItems: 'center',
      gap: 16,
      maxWidth: 540,
      width: 'calc(100vw - 32px)',
      fontFamily: "'Space Grotesk', sans-serif",
    }}>
      <p style={{ margin: 0, fontSize: 13, color: C.dark, flex: 1, lineHeight: 1.5 }}>
        We use cookies to understand how Coda-Vault is used — helping us build a better platform for you.{' '}
        <a href="#privacy" style={{ color: C.blue, textDecoration: 'underline' }}>Privacy Policy</a>
      </p>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button
          onClick={decline}
          style={{
            background: 'transparent',
            border: `2px solid ${C.dark}`,
            borderRadius: 3,
            padding: '6px 12px',
            fontSize: 12,
            fontWeight: 600,
            color: C.dark,
            cursor: 'pointer',
            fontFamily: 'inherit',
            whiteSpace: 'nowrap',
          }}
        >
          Decline
        </button>
        <button
          onClick={accept}
          style={{
            background: C.gold,
            border: `2px solid ${C.dark}`,
            borderRadius: 3,
            padding: '6px 12px',
            fontSize: 12,
            fontWeight: 600,
            color: C.dark,
            cursor: 'pointer',
            fontFamily: 'inherit',
            boxShadow: `2px 2px 0 ${C.dark}`,
            whiteSpace: 'nowrap',
          }}
        >
          Accept
        </button>
      </div>
    </div>
  );
}
